import { createContext } from 'react'
import type { ToolbarAction } from './EditorToolbar.js'

/** Lets a read-only viewer (ImageViewer…) hand its own tools to the
 *  EditorToolbar of the shell that mounted it, instead of floating them over
 *  the content where nobody looks for them.
 *
 *  `null` means no shell owns a toolbar here — the share viewer mounts these
 *  viewers bare — so the viewer falls back to its own overlay. Viewers must
 *  render the same controls either way; only their home differs.
 *
 *  The setter is a `useState` setter, so it is referentially stable and safe
 *  as an effect dependency. Publish from an effect (never during render) and
 *  publish `[]` on unmount, or a switched-away viewer's tools outlive it. */
export const ViewerToolbarContext =
  createContext<((actions: ToolbarAction[]) => void) | null>(null)
